import React from "react";
import PropTypes from "prop-types";
import { getTokenAccessLevel } from "common/auth/token";
import { withStyles } from "@mui/styles";
import { Typography, Drawer, Divider } from "@mui/material";
import AdminNavLinks from "./admin-navlinks";
import SuperadminNavLinks from "./superadmin-navlinks";

import Logo from "../../images/hilo-admin-light.png";

const styles = ({ layout, mixins, spacing }) => ({
  drawerPaper: {
    position: "relative",
    width: layout.drawerWidth,
    height: "100%",
  },
  toolbar: {
    ...mixins.toolbar,
    paddingTop: spacing(2),
    paddingLeft: spacing(3),
    background: "#000",
    boxShadow:
      "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  },
  toolbarHeader: {
    color: "#33ccff",
    textTransform: "uppercase",
  },
});

const Nav = ({ classes }) => {
  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.toolbar}>
        <Typography variant="h6" classes={{ root: classes.toolbarHeader }}>
          <img src={Logo} alt="" height="16" />
        </Typography>
      </div>
      <Divider />
      {getTokenAccessLevel() === "superadmin" ? (
        <SuperadminNavLinks />
      ) : (
        <AdminNavLinks />
      )}
    </Drawer>
  );
};

Nav.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Nav);
